//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { unparse } from 'papaparse';

import { FIELD_LABELS } from '@campaigns/constants/sampling/SamplingBulkUploadLabelsMapping';
import { BULK_UPLOAD_SAMPLE_DATA } from '@campaigns/constants/sampling/SamplingBulkUploadSampleData';
import { saveBlob } from '@utils/saveBlob';

const SAMPLE_DATA_FILE_NAME = 'sampling-products-bulk-upload-template.csv';

export function downloadSamplingBulkUploadTemplate() {
  // Transform each product in the sample data to use friendly field names
  const transformedData = BULK_UPLOAD_SAMPLE_DATA.map((row) => {
    const entries = (
      Object.keys(FIELD_LABELS) as (keyof typeof FIELD_LABELS)[]
    ).map((key) => [
      FIELD_LABELS[key], // The user-friendly label (e.g., "Product Image URL")
      row[key], // The actual value from the product data
    ]);

    // Example: [["imgUrl", "http://..."]] becomes { "Product Image URL": "http://..." }
    return Object.fromEntries(entries);
  });

  const csv = unparse(transformedData);
  saveBlob(csv, SAMPLE_DATA_FILE_NAME, { 'content-type': 'text/csv' });
}
